<script>
  import Url from '@utils/url';

  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');

  import Categories from '@app-components/rec_object/parts/Categories.svelte';
  import Rating from '@app-components/rec_object/parts/Rating.svelte';
  import Neighborhood from '@app-components/rec_object/parts/Neighborhood.svelte';
  import Photos from '@app-components/rec_object/parts/Photos.svelte';
  import RecObjectOptionMenu from '@app-components/RecObjectOptionMenu.svelte';

  export let customGroupStore;

  let group = customGroupStore || groupStore;

  export let recObject;
  export let close;
  export let goToWeblink;
  export let goToPhone;
  export let goToEmail;
  export let goToInstagram;
  export let mobile = false;
  export let showActionBar;
  export let showShareCard;
  export let getWeblinkOrAffilateUrl;

  let totalContactsDisplayed = 0;
  let trackThenGoToRating;
  let showStepTwoModal = false;
  let focusBrokenLink = false;
  const editMode = new URL(location.href).searchParams.has('edit');

  $: hasAddress = recObject.addresses && recObject.addresses.length > 0;

  let displayedContact = function () {
    totalContactsDisplayed += 1;
  };
  if (editMode) {
    setTimeout(() => {
      showStepTwoModal = true;
      focusBrokenLink = true;
    }, 200);
  }
</script>

<style style="text/scss" lang="scss">
  .detail-view-box {
    width: 530px;
    padding: 40px;
    background: #f5f3fc;
    border-radius: 16px;
    flex-shrink: 0;
    height: fit-content;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow-x: hidden;
    max-height: 626px;

    .detail-categories {
      margin-top: -6px;
    }

    .name-rating-container {
      margin-top: 18px;
      display: flex;
      align-items: flex-start;
      /* min-height: 65px; */

      .detail-rating-container {
        flex-shrink: 0;
        position: relative;
        margin: -5px;
        margin-right: -10px;
        cursor: pointer;

        &:hover {
          border-radius: 8px;
          background: #eae4ff;
        }
      }

      .detail-names {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding-right: 30px;

        .detail-name1 {
          font-weight: 500;
          font-size: 24px;
          line-height: 32px;
          word-break: break-word;
          color: black;
        }

        .detail-name2 {
          font-weight: 500;
          font-size: 20px;
          line-height: 32px;
          margin-top: 9px;
          opacity: 0.5;
          word-break: break-word;
        }
      }
    }

    .detail-contact {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      max-height: 64px;
      margin-left: -30px;
      margin-right: -30px;
      // display: grid;
      // grid-row-gap: 60px;

      .detail-contact-single {
        display: flex;
        align-items: center;
        padding-top: 10px;
        width: 100%;
        flex-shrink: 0;
        flex-grow: 0;
        max-width: 100%;
        padding-left: 30px;
        padding-right: 30px;

        a {
          margin-left: 12px;
          color: #8e71ff;
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;

          &:hover {
            color: #7054dc;
          }

          &.broken-link {
            color: #ff5567;
            &:focus {
              color: #cc4452;
            }
            &:hover {
              color: #cc4452;
            }
          }
        }
      }
    }

    .detail-photos-container {
      margin-top: 26px;

      .detail-photos {
        display: flex;
        margin: -8px;
        margin-right: -25px;
        margin-top: -12px;

        .detail-view-photo-wrapper:hover {
          .fit-icon {
            display: block;
          }
        }
        .fit-icon {
          position: absolute;
          right: 10px;
          top: 10px;
          display: none;
        }

        .fit-icon-wrapper {
          position: relative;
        }
      }
    }
  }

  .detail-label {
    display: flex;
    align-items: center;

    .detail-label-name {
      font-size: 14px;
      line-height: 20px;
      color: #1a1a1a;
      opacity: 0.5;
    }

    .detail-label-count {
      font-size: 14px;
      line-height: 12px;
      margin-left: 6px;
    }
  }

  .half-width-contact {
    max-width: 50% !important;
    width: 50% !important;
  }

  .detail-view-photo {
    transition: 0.2s all;
    margin: 8px;
    border-radius: 8px;
    object-fit: cover;

    &:hover {
      box-shadow: 0 1.375rem 6.25rem rgba(0, 0, 0, 0.18);
    }

    &.contain {
      object-fit: contain;
      background-color: white;
    }
  }
</style>

<div class="detail-view-box">
  {#if !mobile && group.permissions.edit && showActionBar}
    <RecObjectOptionMenu
      customGroupStore={customGroupStore}
      detailsViewOption={false}
      showShareCard={showShareCard}
      recObjectId={recObject.id}
      showStepTwoModal={showStepTwoModal}
      focusBrokenLink={focusBrokenLink}
      brokenLinkRelay={recObject.weblink_broken}
      on:removed={() => {
        close();
      }} />
  {/if}

  <div class="detail-categories">
    <Categories
      customGroupStore={customGroupStore}
      spanStyle="font-weight: 500; font-size: 14px; line-height: 17px;"
      recObjectId={recObject.id}
      mobile={mobile}
      showAll={true}
      clickable={false} />
  </div>
  <div class="name-rating-container">
    <div class="detail-names">
      <div class="detail-name1">{recObject.name1}</div>
    </div>
    {#if group.show_review_sites}
      <div class="detail-rating-container" on:click|preventDefault|stopPropagation={trackThenGoToRating}>
        <Rating
          customGroupStore={customGroupStore}
          bind:trackThenGoToRating={trackThenGoToRating}
          recObjectId={recObject.id}
          mobile={mobile} />
      </div>
    {/if}
  </div>
  {#if hasAddress}
    <Neighborhood
      customGroupStore={customGroupStore}
      neighborhoodStyle="font-size: 16px; line-height: 16px; font-weight: 400;"
      style="margin-top: 22px;"
      showFullAddress={true}
      mobile={mobile}
      recObjectId={recObject.id} />
  {/if}

  <div class="detail-contact" style={totalContactsDisplayed == 0 ? 'display: none;' : ''}>
    {#if recObject.weblink && !recObject.hide_weblink}
      <div
        use:displayedContact
        class:half-width-contact={totalContactsDisplayed >= 3}
        class="detail-contact-single detail-url">
        <img
          src={recObject.weblink_broken ? '/images/alert.svg' : '/images/detail-view/link-2.png'}
          style="width: 16px; height: 16px"
          on:click|preventDefault={goToWeblink} />
        <a
          class={recObject.weblink_broken ? 'broken-link' : ''}
          rel="nofollow"
          href={getWeblinkOrAffilateUrl()}
          on:click|preventDefault={goToWeblink}>{Url.urlWithoutHttpsOrWww(recObject.weblink)}</a>
      </div>
    {/if}
    {#if recObject.email && recObject.email != ''}
      <div
        use:displayedContact
        class:half-width-contact={totalContactsDisplayed >= 3}
        class="detail-contact-single detail-email">
        <img
          src="/images/detail-view/email-2.png"
          style="width: 16px; height: 16px"
          on:click|preventDefault={goToEmail} />
        <a href={`mailto:${recObject.email}`} on:click|preventDefault={goToEmail}>{recObject.email}</a>
      </div>
    {/if}
    {#if recObject.instagram_url && recObject.instagram_url != ''}
      <div
        use:displayedContact
        class="detail-contact-single detail-instagram"
        class:half-width-contact={totalContactsDisplayed >= 3}>
        <img
          src="/images/detail-view/instagram-2.png"
          style="width: 16px; height: 16px"
          on:click|preventDefault={goToInstagram} />
        <a href={recObject.instagram_url} on:click|preventDefault={goToInstagram}
          >{recObject.instagram_handle || recObject.instagram_url}</a>
      </div>
    {/if}
    {#if recObject.phone && recObject.phone != ''}
      <div
        use:displayedContact
        class="detail-contact-single detail-phone"
        class:half-width-contact={totalContactsDisplayed >= 3}>
        <img
          src="/images/detail-view/phone-2.png"
          style="width: 16px; height: 16px"
          on:click|preventDefault={goToPhone} />
        <a href={`tel:${recObject.phone}`} on:click|preventDefault={goToPhone}>{recObject.phone}</a>
      </div>
    {/if}
  </div>

  <div class="detail-photos-container">
    <div class="detail-label">
      <span class="detail-label-name">Photos</span>
      <span class="detail-label-count">
        {recObject.rec_object_photos.length}
      </span>
    </div>
    <div class="detail-photos">
      {#if recObject.rec_object_photos && recObject.rec_object_photos.length > 0}
        <Photos
          customGroupStore={customGroupStore}
          extraIdentifier="detail"
          mobile={mobile}
          recObjectId={recObject.id}
          useCarousel={false}
          photosStyle="display: flex; flex-wrap: wrap; margin-bottom: 0px;
          margin-top: 14px;">
          <div slot="img" let:photo>
            <img
              class={`detail-view-photo ${photo.display_style}`}
              alt=""
              src={photo.view_urls.rect_size || photo.view_urls.full_size}
              style="width: {recObject.rec_object_photos.length == 1 ? '302px' : '140px'};
              height: {recObject.rec_object_photos.length == 1 ? '224px' : '104px'};
              margin: 8px; border-radius: 8px;" />
          </div>
        </Photos>
      {:else}
        <img alt="placeholder" style="margin-top: 30px" class="ui-single-photo" src="/images/grid-no-photo.png" />
      {/if}
    </div>
  </div>
</div>
